import React, { useEffect, useMemo, useState } from 'react'
import * as Api from "../../config/Apis"
import endPoints from "../../config/endpoints";
import moment from 'moment/moment';
import { Badge, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faExclamation, faWarning } from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import Pagination from '../../components/pagination';
const tabs = [
  { label: "Owner", value: "createdByUser", count: "totalCreated" },
  { label: "Member", value: "memberOf", count: "totalMemberOf" },
]
export default function Users() {
  let limit = 20
  let navigate = useNavigate()
  const location = useLocation()
  const searchParams = new URLSearchParams(window.location.search)
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [activeuser, setActiveUser] = useState({});
  const [activeTab, setActivetab] = useState(tabs[0].value);
  const [count, setCount] = useState(0);
  // const [params, setParams] = useState({
  //   search: searchParams.get("search") || "",
  //   page: searchParams.get("page") || 1
  // })
  const [modal, setModal] = useState({
    show: false,
    data: null
  })
  const [search, setSearch] = useState(searchParams.get("search") || "")
  const [page, setPage] = useState(Number(searchParams.get("page")) || 1)
  const [debouncedSearch, setDebouncedSearch] = useState(search);

  const query = useMemo(() => {
    const qs = new URLSearchParams();

    if (debouncedSearch) {
      qs.append("search", debouncedSearch);
    }

    qs.append("page", page);

    return qs.toString();
  }, [debouncedSearch, page]);

  // useEffect(() => {
  //   setParams({
  //     ...params,
  //     page: page
  //   })
  // }, [page])
  const handleClose = () => {
    setModal({ show: false, data: null })
    setActivetab(tabs[0].value)
    setActiveUser({})
  }
  const handleTab = (item) => {
    setActivetab(item.value)
  }
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search.trim());
      setPage(1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [search]);


  const searchUser = (e) => {
    setSearch(e.target.value);
  };

  const getUsers = (param) => {
    Api.GetApi(`${endPoints.USERLIST}${param}`).then(res => {
      setLoading(false)
      if (res.error === true) {
        Api.Alert(res.response.data.error, "error")
      } else {
        if (res.data.data && res.data.data.data) {
          setUsers(res.data.data?.data || []);
          setCount(res.data.data?.totalCount?.count || 0);
        }
      }
    })
  }
  const getUserDetail = (item) => {
    Api.GetApi(endPoints.USERDETAIL + `/${item?._id}`).then(res => {
      setLoading(false)
      if (res.error === true) {
        Api.Alert(res.response.data.error, "error")
      } else {
        if (res.data.data) {
          setActiveUser(item);
          setModal({ show: true, data: res.data.data })
        }
      }
    })
  }

  const showDetail = (item) => {
    getUserDetail(item)
  }

  const buildQuery = (params) => {
    const qs = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== "" && value !== null && value !== undefined) {
        qs.append(key, value);
      }
    });

    return qs.toString();
  };
  useEffect(() => {
    const newSearch = query ? `?${query}` : "";

    if (location.search !== newSearch) {
      navigate(
        {
          pathname: location.pathname,
          search: newSearch
        },
        { replace: true }
      );
    }
  }, [query]);

  useEffect(() => {
    getUsers(location.search);
  }, [location.search]);

  return (
    <main>
      <div className='container-fluid'>
        <div className='card'>
          <div className='card-body'>
            <div className="d-flex gap-1 align-items-center justify-content-between">
              <h1>Users</h1>
              <div className="d-flex gap-1 align-items-center">
                Search:
                <input type="text" className="form-control search_input px-3" autoComplete="off" value={search} onChange={searchUser} />
              </div>
            </div>
            <div className='user_table'>
              <table className='table'>
                <thead>
                  <tr>
                    <th width={80}>#</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Platform</th>
                    <th width="200">Date</th>
                    <th width="200">Last login</th>
                  </tr>
                </thead>
                {loading ?
                  <tbody>
                    <tr>
                      <td colSpan={6} className='text-center'><strong>Loading...</strong></td>
                    </tr>
                  </tbody>
                  :
                  users.length === 0 && !loading ?
                    <tbody>
                      <tr>
                        <td colSpan={6} className='text-center'>No data found.</td>
                      </tr>
                    </tbody> :
                    <tbody>
                      {users.map((item, index) => {
                        let updInd = index + 1
                        return (
                          <tr key={index}>
                            <td style={{ cursor: "pointer" }} onClick={() => navigate(`/users/${item?._id}`)}>{(page - 1) * limit + updInd}</td>
                            <td style={{ cursor: "pointer" }} onClick={() => navigate(`/users/${item?._id}`)}>{item.first_name} {item.last_name || ""}</td>
                            <td style={{ cursor: "pointer" }} onClick={() => navigate(`/users/${item?._id}`)}>
                              {item.email}
                            </td>
                            <td style={{ cursor: "pointer" }} onClick={() => navigate(`/users/${item?._id}`)} className='text-uppercase'>{item?.userDevice?.platform || "-"}</td>
                            <td style={{ cursor: "pointer" }} onClick={() => navigate(`/users/${item?._id}`)}>{moment(item.createdAt).format("lll")}</td>
                            <td style={{ cursor: "pointer" }} onClick={() => navigate(`/users/${item?._id}`)}>
                              {item.updatedAt ? moment(item.updatedAt).format("lll") : "-"}
                              {/* <button className='btn btn-sm' onClick={() => showDetail(item)}>View</button> */}
                            </td>
                          </tr>
                        )
                      }
                      )}
                    </tbody>
                }
              </table>
              <Pagination total={count} perPage={limit} page={page} setPage={setPage} />
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}
